import { FaTrash } from "react-icons/fa";
import { Button } from "primereact/button";

const DeleteButton = ({ onClick }) => {
    return (
        <Button
            type="button"
            icon={<FaTrash size={"0.9rem"} />}
            className="action-body-btn action-body-btn-red"
            tooltip="Eliminar"
            tooltipOptions={{ position: "top" }}
            onClick={onClick}
            aria-label="eliminar"
        />
    );
};

export default DeleteButton;